import React from 'react';
import type { ComponentProps } from 'react';
import styled from '@emotion/styled';
import { minHeight, minWidth, size } from 'styled-system';

import IconBase from '../Icon';

const iconResponsiveSizes = ['24px', null, null, '28px'];

const UnstyledIcon = styled(IconBase)<any>`
  ${size};
  ${minHeight};
  ${minWidth};
`;

const Icon = (props: ComponentProps<typeof UnstyledIcon>) => (
  <UnstyledIcon
    size={iconResponsiveSizes}
    minHeight={iconResponsiveSizes}
    minWidth={iconResponsiveSizes}
    {...props}
  />
);

export default Icon;
